import { render } from "./NeuHeaderSektion.vue?vue&type=template&id=36f0d793&scoped=true"
import script from "./NeuHeaderSektion.vue?vue&type=script&lang=js"
export * from "./NeuHeaderSektion.vue?vue&type=script&lang=js"

import "./NeuHeaderSektion.vue?vue&type=style&index=0&id=36f0d793&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f0d793"]])

export default __exports__